<template lang="pug">

v-footer.modern-footer(app absolute)
  .footer-content
    .footer-text
      | 2016 - {{ currentYear }} © Timetable, All Rights Reserved

</template>

<script>
export default {
  name: 'Footer',

  data() {
    return {
      currentYear: new Date().getFullYear(),
    }
  },
}
</script>

<style lang="sass" scoped>

.modern-footer.v-footer
  background: linear-gradient(135deg, #2c3e50 0%, #34495e 100%) !important
  color: rgba(255,255,255,0.8)
  height: 40px !important
  border-top: 1px solid rgba(255,255,255,0.1)

.footer-content
  display: flex
  align-items: center
  justify-content: center
  width: 100%
  max-width: 1200px
  margin: 0 auto
  padding: 0 24px

.footer-text
  font-size: 12px
  color: rgba(255,255,255,0.6)
  text-align: center

// Mobile responsive
@media (max-width: 768px)
  .footer-content
    padding: 0 16px

  .footer-text
    font-size: 11px

@media (max-width: 480px)
  .footer-text
    font-size: 10px
</style>
